module.exports = __webpack_public_path__ + "img/leonardo-da-vinci-min.af5b3b74.png";